module.exports = __webpack_public_path__ + "img/08.6e5e245b.jpg";